module.exports = __webpack_public_path__ + "img/晕.daa0a7f1.gif";